var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSelectedStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_3217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 0H8.25745V4.74292H10.0405V0Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 11.2551H8.25745V15.998H10.0405V11.2551Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9175 7.10849H12.1746V8.8915H16.9175V7.10849Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66238 7.10849H0.919464V8.8915H5.66238V7.10849Z",
    fill: "#D1EF70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_3217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.919464)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectedStar);
export default __webpack_public_path__ + "static/media/icon-selected-star.b2154efeadd322adb3fd593315b570f6.svg";
export { ForwardRef as ReactComponent };